import { ReactElement } from 'react';

import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';
import { RecordContextProvider } from 'react-admin';
import { Box } from 'shared/mui/Box';
import { FunctionField, OrderStatusChipField } from 'shared/react-admin/Fields';
import { OrderAdjustments } from 'types/embedded/orderAdjustments';

export type AdjustmentChangeStatusFieldProps = {
  label?: string | ReactElement | boolean;
  source?: string;
};

export const AdjustmentChangeStatusField: React.FC<AdjustmentChangeStatusFieldProps> = ({
  label,
  source,
}) => {
  return (
    <FunctionField
      label={label}
      render={(record: OrderAdjustments) => {
        return (
          <Box sx={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
            <RecordContextProvider value={record.oldStatus}>
              <OrderStatusChipField source="description" />
            </RecordContextProvider>
            <RecordContextProvider value={record.newStatus}>
              <Box sx={{ display: 'flex', alignItems: 'center' }}>
                <KeyboardArrowRightIcon fontSize="small" />
                <OrderStatusChipField source="description" />
              </Box>
            </RecordContextProvider>
          </Box>
        );
      }}
      source={source}
    />
  );
};
